import { render, staticRenderFns } from "./SpecialsForm.vue?vue&type=template&id=1a841e2a&scoped=true&"
import script from "./SpecialsForm.vue?vue&type=script&lang=js&"
export * from "./SpecialsForm.vue?vue&type=script&lang=js&"
import style0 from "./SpecialsForm.vue?vue&type=style&index=0&id=1a841e2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a841e2a",
  null
  
)

export default component.exports